import { render } from "./vbreadcrumb.vue?vue&type=template&id=106f3608"
import script from "./vbreadcrumb.vue?vue&type=script&lang=js"
export * from "./vbreadcrumb.vue?vue&type=script&lang=js"

import "./vbreadcrumb.vue?vue&type=style&index=0&id=106f3608&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__